import React, { useCallback, useContext } from "react";
import { StyledCard } from "./styled";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { LazyLoadImage } from "react-lazy-load-image-component";
import CustomIcon from "components/customIcon";
import Empty from "assets/img/empty.webp";
import { get, isEmpty } from "lodash";
import "react-lazy-load-image-component/src/effects/blur.css";
import "swiper/css";
import "swiper/css/pagination";
import { LanguageContext } from "components/language";
import { pink } from "@mui/material/colors";
import Currency from "components/Currency";
import { getNutirationText } from "utils/functions";
import pet from "assets/icons/pet.svg";

const Card = ({ rate, setRoom, design, room = {}, selected = {}, dateRange = {} }) => {
    const { t } = useContext(LanguageContext);

    const bedsCount = useCallback((room) => {
        return get(room, "beds", []).reduce(
            (previousValue, currentValue) => previousValue + currentValue?.amount,
            0
        );
    }, []);

    return (
        <StyledCard design={design}>
            <div className="swiperCard">
                {get(room, "recommended", false) && (
                    <div className="top-text">{t("WE_RECOMMEND")}</div>
                )}

                {get(room, "amenities", []).find((item) => item.name === "Petty Friendly") ? (
                    <img className="pet_icon" src={pet} alt="d" />
                ) : null}

                <Swiper
                    style={{
                        "--swiper-pagination-color": "grey",
                        "--swiper-pagination-bullet-inactive-color": "#fff",
                        "--swiper-pagination-bullet-inactive-opacity": "1",
                        "--swiper-pagination-bullet-size": "14px",
                        "--swiper-pagination-bullet-horizontal-gap": "6px",
                    }}
                    pagination={{
                        dynamicBullets: true,
                        clickable: true,
                    }}
                    modules={[Pagination]}
                    className="mySwiper"
                >
                    {!isEmpty(get(room, "attachments", [])) ? (
                        get(room, "attachments", [])?.map((item) => (
                            <SwiperSlide key={item.id}>
                                <LazyLoadImage
                                    width={"100%"}
                                    height={"100%"}
                                    src={item?.downloadUriByNginx}
                                    effect="blur"
                                />
                            </SwiperSlide>
                        ))
                    ) : (
                        <SwiperSlide>
                            <img src={Empty} alt="img" />
                        </SwiperSlide>
                    )}
                </Swiper>

                <div className="swiper-bottom">
                    <div className="left">
                        <div>
                            <CustomIcon icon="kvadrat" />
                            <p>{get(room, "sizeRoom", "")}m2</p>
                        </div>
                        <div>
                            <CustomIcon icon="bedcard" />
                            <p>{bedsCount(room)}</p>
                        </div>
                        <div>
                            <CustomIcon icon="doubleuser" />
                            <p>{get(room, "roomCapacity", "")}</p>
                        </div>
                    </div>
                    <div className="right">
                        <div>
                            {get(room, "amenities", [])
                                .filter((item) => item.name != "Petty Friendly")
                                ?.map((item) => (
                                    <CustomIcon
                                        sx={{ color: pink[500] }}
                                        key={item.iconCode}
                                        icon={item?.iconCode || "wifi"}
                                    />
                                ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="cardContent">
                <div className="DescriptionCard">{get(room, "name", "")} </div>
                <div className="contentText">
                    <div className="left">
                        {getNutirationText(rate, t)}
                        {get(room, "beds", [])?.map(({ type, amount, sizeX, sizeY }, i) => (
                            <React.Fragment key={i}>
                                <br />
                                {amount} {t(type)} {sizeX || ""}
                                {sizeY ? `*${sizeY}` : ""} {sizeY ? "cm" : ""};
                            </React.Fragment>
                        ))}
                    </div>
                    <div className="right">
                        {rate.isDiscount ? (
                            <h3>
                                {get(room, `rateDiscountPrices.${rate.id}.priceWithoutDiscount`)}
                            </h3>
                        ) : null}
                        <h2>
                            {rate.isDiscount
                                ? get(room, `rateDiscountPrices.${rate.id}.price`)
                                : get(room, "price")}
                            <Currency code={rate.currencyCode} />
                            <span className="days">
                                {" "}
                                / {get(room, "howManyDays", 0)} {t("NIGHTS")}
                            </span>
                        </h2>
                    </div>
                </div>
            </div>
            <div className={"cardBtn " + (selected?.categoryId === room.id ? "selected" : "")}>
                <button onClick={() => setRoom(room.id, room.name)}>
                    <span>{selected?.categoryId === room.id ? t("SELECTED") : t("BOOK")}</span>
                </button>
            </div>
        </StyledCard>
    );
};

export default Card;
